import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Popup from 'ati-ui-react/components/Popup';
import Badge from 'ati-ui-react/components/Badge';
import isEmpty from 'lodash/isEmpty';
import ReportButton from '../ReportButton';
import checkvin from './img/checkvin.svg';
import vin from './img/vin.svg';

import {
  GovNumVinPopupContainer,
  ContentTabs,
  Tabs,
  Tab,
  Content,
  ReportButtonContainer,
} from './GovNumVinPopupStyles';

const GovNumVinPopup: FC = observer(() => {
  const [active, setActive] = useState(0);

  const {
    advertsStore: {
      // @ts-ignore
      currentAdvert: { full_report_exists, full_report_available },
    },
    checksStore: {
      isShowPopupGovNumVin,
      setCloseShowPopupGovNumVin,
      setDesciption,
      priceReport,
      priceGovNumVin,
      tractionType,
    },
  } = useStores();

  useEffect(() => {
    return () => setCloseShowPopupGovNumVin();
  }, []);

  const onHandleToggle = (e: React.MouseEvent<HTMLDivElement>): void => {
    const index = parseInt(e.currentTarget.id, 10);
    if (index !== active) {
      setActive(index);
    }
  };

  const renderIfCheckReportExists = () => {
    return (
      <>
        <Tabs>
          <Tab className="report" onClick={onHandleToggle} active={active === 0} id={0}>
            <img src={checkvin} alt="ckeckvin" />
            <span className="title">
              Полный отчет {!isEmpty(tractionType) && `${tractionType}a`} по VIN
            </span>
            <div>
              <Badge
                color="gray"
                className={active === 0 ? 'custom-badge' : 'custom-badge-unactive '}
              >
                <b>{priceReport} ат.</b>
              </Badge>
              <span className="badge-description">{priceReport} руб.</span>
            </div>
            <div className="description">
              <ul className="list">
                <li>- общие сведения</li>
                <li>- сведения об ограничениях</li>
                <li>- история владения</li>
                <li>- сведения о ДТП</li>
              </ul>
            </div>
          </Tab>

          <Tab className="show-number" onClick={onHandleToggle} active={active === 1} id={1}>
            <img src={vin} alt="vin" />
            <span className="title">{setDesciption('simpleText')}</span>
            <div>
              <Badge
                color="green"
                className={active === 1 ? 'custom-badge' : 'custom-badge-unactive '}
              >
                <b>{priceGovNumVin} ат.</b>
              </Badge>
              <span className="badge-description">{priceGovNumVin} руб.</span>
            </div>
            <div className="description">
              Узнайте номер и VIN, чтобы иметь возможность получить больше информации о ТС
            </div>
          </Tab>
        </Tabs>
        <ContentTabs>
          <Content active={active === 0}>
            <ReportButton />
          </Content>

          <Content active={active === 1}>
            <ReportButton forGovNumVin />
          </Content>
        </ContentTabs>
      </>
    );
  };

  const renderIfCheckReportNotExists = () => {
    return (
      <>
        <div className="checks-show-number" onClick={onHandleToggle}>
          <img src={vin} alt="vin" />
          <span className="title">{setDesciption('simpleText')}</span>
          <div>
            <Badge color="gray">
              <b>{priceGovNumVin} ат.</b>
            </Badge>
            <span className="badge-description">{priceGovNumVin} руб.</span>
          </div>
          <div className="description">
            Узнайте номер и VIN, чтобы иметь возможность получить больше информации о ТС
          </div>
        </div>
        <ReportButtonContainer>
          <ReportButton forGovNumVin />
        </ReportButtonContainer>
      </>
    );
  };

  // 1. флаг full_report_exists: false в поп-апе “купить отчет” не выводим, здесь флаг full_report_available не приходит
  // 2. full_report_available: false / full_report_exists: true - отчет есть но нет доступа к нему, выводим “купить отчет” в поп-апе
  // 3. full_report_available: true / full_report_exists: true - не выводим “купить отчет” в поп-апе

  return (
    <>
      {isShowPopupGovNumVin && (
        <Popup
          title={setDesciption('simpleText')}
          whiteActionArea
          closeOnOverlayClick
          onClose={() => setCloseShowPopupGovNumVin()}
        >
          <GovNumVinPopupContainer>
            {full_report_exists && !full_report_available
              ? renderIfCheckReportExists()
              : renderIfCheckReportNotExists()}
          </GovNumVinPopupContainer>
        </Popup>
      )}
    </>
  );
});

export default GovNumVinPopup;
